﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ArrayUtils
 * @description
 * # ArrayUtils
 */

angular.module('ntmApp')
    .run(function () {

        if (!Array.prototype.firstOrDefault) {
            Array.prototype.firstOrDefault = function (condition) {
                
                for (var i = 0, length = this.length; i < length; i++) {
                    if (condition(this[i])) {
                        return this[i];
                    }
                }

                return null;
            };
        }

        if (!Array.prototype.insert) {
            Array.prototype.insert = function (index, item) {
                this.splice(index, 0, item);
            };
        }

        if (!Array.prototype.remove) {
            Array.prototype.remove = function (item) {
                var index = this.indexOf(item);

                if (index > -1) {
                    this.splice(index, 1);
                }
            };
        }

        if (!Array.prototype.removeWhere) {
            Array.prototype.removeWhere = function (condition) {
                var foundItems = this.filter(condition);

                if (foundItems) {
                    foundItems.forEach(function (item) {
                        this.remove(item);
                    });
                }
            };
        }
        if (!Array.prototype.unique) {
            Array.prototype.unique = function (compareAction) {
                var result = this.concat();
                for (var i = 0; i < result.length; ++i) {
                    for (var j = i + 1; j < result.length; ++j) {

                        if (compareAction) {

                            if(compareAction(result[i], result[j])) {
                                result.splice(j--, 1);
                            }

                        } else {

                            if (result[i] === result[j]) {
                                result.splice(j--, 1);
                            }
                        }
                    }
                }

                return result;
            };
        }

        if (!Array.prototype.uniqueUnion) {
            Array.prototype.uniqueUnion = function (array) {
                return this.concat(array).unique();
            };
        }

        if (!Array.prototype.groupBy) {
            Array.prototype.groupBy = function (groupByObj) {
                
                var groups = [];

                this.forEach(function (item) {

                    var groupItem = groups.firstOrDefault(function (group) {
                        return angular.isFunction(groupByObj) ? group.key === groupByObj(item) : group.key === item[groupByObj];
                    });

                    if (groupItem) {
                        groupItem.items.push(item);
                    } else {
                        var newGroup = {
                            key: angular.isFunction(groupByObj) ? groupByObj(item) : item[groupByObj],
                            items: [item]
                        };

                        groups.push(newGroup);
                    }

                });


                return groups;

            };
        }

        if (!Array.prototype.sortBy) {
            Array.prototype.sortBy = function (comparer, property) {

                return this.sort(function (item1, item2) {

                    if (property) {
                        return comparer(item1[property], item2[property]);
                    }

                    return comparer(item1, item2);
                });
            };
        }

        if (!Array.prototype.sumOf) {
            Array.prototype.sumOf = function (property) {

                var sum = 0;

                this.forEach(function (item) {
                    sum += item[property];
                });

                return sum;
            };
        }

    });